import validator from "./validator";
import general from "./general";
export default {
  validator,
  general,
};
